export function getConfig(p = {}) {

    const { config = {} } = p

    const commonConfig = config.common || {}
    //const globalsConfig = config.globals || {};

    const common = {
        ...commonConfig,
        siteName: 'VLM UI',
        description: 'VLM UI'
    }

    return {
        config: {
            ...config,
            common: common
        }
    }
}
